var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"title":_vm.$dt(_vm.bulletinData,'NOTICE_NAME')}},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.$dt(_vm.bulletinData,'CONTENT'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }